"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Title",
      prop: "title"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 1,
      autosize: {
        minRows: 1,
        maxRows: 2
      },
      name: "title",
      required: "",
      maxlength: "150",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.title,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "title", $$v);
      },
      expression: "formData.title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Message",
      prop: "message"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 2,
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      name: "message",
      maxlength: "250",
      "show-word-limit": "",
      required: ""
    },
    model: {
      value: _vm.formData.message,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "message", $$v);
      },
      expression: "formData.message"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Image",
      prop: "image"
    }
  }, [_c("el-upload", {
    attrs: {
      "file-list": _vm.image,
      "on-change": _vm.imageUpload,
      "list-type": "picture",
      action: "https://growapi.alembic.co.in/common/upload",
      limit: 1
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v(" Click to upload ")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "UtmSource",
      prop: "utmSource"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 2,
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      name: "utmSource",
      maxlength: "100",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.utmSource,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "utmSource", $$v);
      },
      expression: "formData.utmSource"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "UtmCampaign",
      prop: "utmCampaign"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 2,
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      name: "utmCampaign",
      maxlength: "100",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.utmCampaign,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "utmCampaign", $$v);
      },
      expression: "formData.utmCampaign"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "UtmMedium",
      prop: "utmMedium"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 2,
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      name: "utmMedium",
      maxlength: "100",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.utmMedium,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "utmMedium", $$v);
      },
      expression: "formData.utmMedium"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "IsDeletable (for Announcement)",
      prop: "isDeletable"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isDeletable,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isDeletable", $$v);
      },
      expression: "formData.isDeletable"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "IsVisible (for Announcement)",
      prop: "isVisible"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isVisible,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isVisible", $$v);
      },
      expression: "formData.isVisible"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Send to All",
      prop: "sendToAll"
    }
  }, [_c("el-switch", {
    on: {
      change: _vm.sendToAllToggled
    },
    model: {
      value: _vm.formData.sendToAll,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sendToAll", $$v);
      },
      expression: "formData.sendToAll"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Redirect Page"
    }
  }, [_c("el-select", {
    attrs: {
      name: "page",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.page,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "page", $$v);
      },
      expression: "formData.page"
    }
  }, _vm._l(_vm.pages, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Link",
      prop: "link"
    }
  }, [_c("el-input", {
    attrs: {
      type: "link",
      name: "link",
      required: ""
    },
    model: {
      value: _vm.formData.link,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "link", $$v);
      },
      expression: "formData.link"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_vm._v(" https:// ")])], 2)], 1), !_vm.formData.sendToAll ? [_c("el-form-item", {
    attrs: {
      label: "App Version",
      prop: "appVersion"
    }
  }, [_c("el-select", {
    attrs: {
      name: "appVersion",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.appVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "appVersion", $$v);
      },
      expression: "formData.appVersion"
    }
  }, _vm._l(_vm.appVersionList, function (appVersion) {
    return _c("el-option", {
      key: appVersion,
      attrs: {
        label: appVersion,
        value: appVersion
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Type"
    }
  }, [_c("el-select", {
    attrs: {
      name: "Type",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "type", $$v);
      },
      expression: "formData.type"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1), _vm.formData.type === "App Opened" ? _c("el-form-item", {
    attrs: {
      label: "App Opened"
    }
  }, [_c("el-select", {
    attrs: {
      name: "App Opened",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.appOpened,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "appOpened", $$v);
      },
      expression: "formData.appOpened"
    }
  }, _vm._l(_vm.lastSevenDates, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1) : _vm._e(), ["Division", "Not Changed Rank", "Rank Increased", "Rank Decreased", "ZMLocation", "RMLocation", "AMLocation", "MRLocation", "EmployeesRole"].includes(_vm.formData.type) ? _c("el-form-item", {
    attrs: {
      label: "Division"
    }
  }, [_c("el-select", {
    attrs: {
      name: "Division",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    on: {
      change: _vm.getRMLocations
    },
    model: {
      value: _vm.formData.divisionId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "divisionId", $$v);
      },
      expression: "formData.divisionId"
    }
  }, _vm._l(_vm.divisionList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.type === "Zone" ? _c("el-form-item", {
    attrs: {
      label: "Zone"
    }
  }, [_c("el-select", {
    attrs: {
      multiple: "",
      name: "Zone",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.zoneId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "zoneId", $$v);
      },
      expression: "formData.zoneId"
    }
  }, _vm._l(_vm.zoneList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.type === "ZMLocation" ? _c("el-form-item", {
    attrs: {
      label: "ZMLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "ZMLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.zmLocationId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "zmLocationId", $$v);
      },
      expression: "formData.zmLocationId"
    }
  }, _vm._l(_vm.zmLocationList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.divisionId.length && _vm.formData.type === "Not Changed Rank" ? _c("el-form-item", {
    attrs: {
      label: "Not Changed Rank RMLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "RMLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.regionId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "regionId", $$v);
      },
      expression: "formData.regionId"
    }
  }, _vm._l(_vm.rmLocationUnchangeRankList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.divisionId.length && _vm.formData.type === "Rank Increased" ? _c("el-form-item", {
    attrs: {
      label: "Increased Rank RMLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "RMLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.regionId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "regionId", $$v);
      },
      expression: "formData.regionId"
    }
  }, _vm._l(_vm.rmLocationUpRankList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.divisionId.length && _vm.formData.type === "Rank Decreased" ? _c("el-form-item", {
    attrs: {
      label: "Decreased Rank RMLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "RMLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.regionId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "regionId", $$v);
      },
      expression: "formData.regionId"
    }
  }, _vm._l(_vm.rmLocationDownRankList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.divisionId.length && (_vm.formData.type === "RMLocation" || _vm.formData.type === "AMLocation" || _vm.formData.type === "MRLocation") ? _c("el-form-item", {
    attrs: {
      label: "RMLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "RMLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    on: {
      change: _vm.getAMLocations
    },
    model: {
      value: _vm.formData.regionId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "regionId", $$v);
      },
      expression: "formData.regionId"
    }
  }, _vm._l(_vm.rmLocationList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.regionId.length && (_vm.formData.type === "AMLocation" || _vm.formData.type === "MRLocation") ? _c("el-form-item", {
    attrs: {
      label: "AMLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "AMLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    on: {
      change: _vm.getMRLocations
    },
    model: {
      value: _vm.formData.amLocationId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "amLocationId", $$v);
      },
      expression: "formData.amLocationId"
    }
  }, _vm._l(_vm.amLocationList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.amLocationId.length && _vm.formData.type === "MRLocation" ? _c("el-form-item", {
    attrs: {
      label: "MRLocation"
    }
  }, [_c("el-select", {
    attrs: {
      name: "MRLocation",
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      filterable: "",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.mrLocationId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mrLocationId", $$v);
      },
      expression: "formData.mrLocationId"
    }
  }, _vm._l(_vm.mrLocationList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.formData.type === "EmployeesRole" ? _c("el-form-item", {
    attrs: {
      label: "Employees Role"
    }
  }, [_c("el-select", {
    attrs: {
      name: "EmployeesRole",
      multiple: "",
      clearable: "",
      filterable: "",
      "multiple-limit": "3",
      "auto-complete": "off"
    },
    model: {
      value: _vm.formData.employeeRoleId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "employeeRoleId", $$v);
      },
      expression: "formData.employeeRoleId"
    }
  }, _vm._l(_vm.employeesRoleList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e()] : _vm._e(), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Send")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 2)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;